import React from 'react';
import { motion } from 'framer-motion';
import { Wind, MessageSquareHeart, Handshake } from 'lucide-react';
const phases = [{
  days: 'Día 1 al 3',
  title: 'Tregua invisible',
  desc: "Limpiamos el ruido y aplicamos la 'tregua invisible' para que él baje la guardia sin darse cuenta.",
  icon: Wind
}, {
  days: 'Día 4 al 6',
  title: 'Preguntas poderosas',
  desc: 'Usamos preguntas específicas y establecemos límites con empatía para reabrir el canal de escucha.',
  icon: MessageSquareHeart
}, {
  days: 'Día 7',
  title: 'Nuevo compromiso',
  desc: 'Sellamos el nuevo compromiso de convivencia y establecemos rituales de conexión duraderos.',
  icon: Handshake
}];
export function HowItWorksSection() {
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-89">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-90">
        <div className="text-center mb-10 md:mb-16" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold text-maternal-brown mb-4" data-id="element-92">
            Tu hoja de ruta de 7 días
          </h2>
          <p className="text-lg text-maternal-lightBrown" data-id="element-93">
            Un proceso claro, día por día, diseñado para transformar la tensión
            en conexión.
          </p>
        </div>

        <div className="relative" data-id="element-94">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute left-[50%] top-0 bottom-0 w-1 bg-maternal-amber/30 -translate-x-1/2 rounded-full" data-id="element-95"></div>

          <div className="space-y-12 relative" data-id="element-96">
            {phases.map((phase, index) => {
            const Icon = phase.icon;
            const isEven = index % 2 === 0;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.2
            }} className={`flex flex-col md:flex-row items-center gap-8 ${isEven ? 'md:flex-row-reverse' : ''}`} data-id="element-97">
                  {/* Content */}
                  <div className={`flex-1 w-full bg-white p-6 md:p-8 rounded-2xl shadow-md border border-maternal-cream ${isEven ? 'md:text-left' : 'md:text-right text-left'}`} data-id="element-98">
                    <span className="inline-block px-3 py-1 bg-maternal-cream text-maternal-orange font-bold rounded-full text-sm mb-4" data-id="element-99">
                      {phase.days}
                    </span>
                    <h3 className="text-2xl font-bold text-maternal-brown mb-3" data-id="element-100">
                      {phase.title}
                    </h3>
                    <p className="text-maternal-lightBrown leading-relaxed" data-id="element-101">
                      {phase.desc}
                    </p>
                  </div>

                  {/* Center Icon */}
                  <div className="hidden md:flex relative z-10 w-16 h-16 bg-gradient-to-br from-maternal-amber to-maternal-gold rounded-full items-center justify-center shadow-lg border-4 border-maternal-beige flex-shrink-0" data-id="element-102">
                    <Icon className="w-8 h-8 text-white" data-id="element-103" />
                  </div>

                  {/* Empty space for alignment */}
                  <div className="hidden md:block flex-1" data-id="element-104"></div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}